import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

const OutlinedButton = (props) => {
    const { title, styleOverrides, handleClick, ...others } = props;

    return (
        <Button
            variant={'contained'}
            color="primary"
            style={styleOverrides || null}
            type='button'
            onClick={handleClick}
            {...others}
        >
            {title}
        </Button>
    );
};

OutlinedButton.prototypes = {
    title: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    styleOverrides: PropTypes.object,
    disabled: PropTypes.bool,
};

export default OutlinedButton;
